/**
 * GEN-E-99 — a scaled module zooms itself down on a small screen, which is what a 75-80% browser zoom does by
 * hand on a 1366x768 laptop, instead of every screen being re-laid out for it.
 *
 * GEN-E-99-52 — width only: `clamp(0.75, innerWidth / 1700, 1)`. The height axis (÷ 960) was dropped: it read
 * `innerHeight`, which is the screen less the browser's tabs, address bar and taskbar, so a 1920x1080 monitor
 * (innerHeight ≈ 937) came out 0.98 instead of 1, and a real 1366x768 laptop (innerHeight ≈ 650) 0.75 instead
 * of 0.80. Width does not move with the browser chrome: 1366 → 0.80, 1920 → 1.
 *
 * GEN-E-107-09 — above FHD the base stays 1 (owner, 2026-10-22): 2K and 4K get the 1920 zoom, so the tiers read
 * 0.9 / 1 / 1.1 there too. This supersedes the GEN-E-107-04 step-up (1.1 / 1.2 / 1.3 by screen class).
 * Design: ITPKV large-screen-base-scale.md. Keep in step with the index.html pre-boot.
 */
const DESIGN_WIDTH = 1700;
const MIN_SCALE = 0.75;

/** The zoom for a viewport width, to two decimals: [0.75, 1], reaching 1 at 1700 and staying 1 above. Unknown (zero) width: 1. */
export function viewportScale(width: number): number {
  if (!width) return 1;
  return Math.round(Math.min(1, Math.max(MIN_SCALE, width / DESIGN_WIDTH)) * 100) / 100;
}

